import MainAppGenericModal from "components/MainApp/atoms/Modals/GenericModal";
import ImgExchange from "assets/images/exchange_1.gif";
import i18n from "i18n";
import styles from "./ModalGuardProcessingInfo.module.scss";

const ModalGuardProcessingInfo = ({ 
  open,
  headerText = null,
  bodyText = null
}) => {
  const defaultHeader = i18n.t("processing.theft.alert.header");
  const defaultBody = i18n.t("processing.theft.alert.body");

  return (
    <MainAppGenericModal
      open={open}
      content={
        <section className={styles["info-processing-modal"]}>
          <div className={styles["info-processing-content"]}>
            <div className={styles["info-processing-image-background"]}>
              <img
                src={ImgExchange}
                alt="img exchange"
                className={styles["info-processing-img"]}
              />
            </div>
            <div className={styles["info-processing-modal-msg"]}>
              <div className={styles["info-processing-modal-header"]}>
                {headerText || defaultHeader}
              </div>
              <div className={styles["info-processing-modal-text"]}>
                {bodyText || defaultBody}
              </div>
            </div>
          </div>
        </section>
      }
      classContainer={styles["info-processing-modal-container"]}
      classModalContainer={styles["info-processing-modal-modal-container"]}
      disableClose
    />
  );
};

export default ModalGuardProcessingInfo;